import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, input, model } from '@angular/core';
import type { WaHideEvent } from '@web.awesome.me/webawesome-pro';

@Component({
    selector: 'app-ciq-dialog',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    templateUrl: './ciq-dialog.html',
    styleUrl: './ciq-dialog.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CiqDialog {
    readonly open = model(false);
    readonly label = input<string>();
    readonly lightDismiss = input(true);

    protected onHide(event: WaHideEvent) {
        const target = event.target as HTMLElement;

        // Only respond to the dialog's own hide event, not nested elements
        if (!target.localName.includes('wa-dialog')) {
            return;
        }

        this.open.set(false);
    }
}
